import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from 'rxjs';

import { AuthService } from "@core/authentication/auth.service";

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  public subscription: Subscription;
  emailForm: FormGroup;
  resetForm: FormGroup;
  public submitted: boolean;
  public userData: any;
  public userId: any;
  public msg: any = {
    isError: false,
    msg: ""
  };

  public isLoading: boolean = false;
  public code: String;
  public isReset: boolean = false;

  constructor(private formBuilder: FormBuilder, private _service: AuthService,
    private _router: Router) { }

  ngOnInit() {
    this.checkLogin();

  }

  checkLogin() {
    if (localStorage.getItem("userData")) {
      this.isLoading = true;
      this.userData = JSON.parse(atob(localStorage.getItem("userData")));
      this.callReset(this.userData);
    } else {
      this.emailForm = this.formBuilder.group({
        email: ["", [Validators.required, Validators.email]],
      });
    }
  }

  resetPassword() {
    this.submitted = true;
    if (this.emailForm.invalid) 
      return

    this.callReset(this.emailForm.get("email").value);   
  }

  callReset(data) {
    let email = {
      "email": data
    }
    this.subscription = this._service.emailResetCode(email)
      .subscribe((res) => {
        this.userId = res.userId;
        this.msg.msg = res.message;
        this.msg.isError = false;
        this.isLoading = false;
        localStorage.setItem("data",btoa(JSON.stringify(data)));
        
        setTimeout(() => {
          this.msg.msg = "";
        }, 2000);
      }, err => {
        this.msg.msg = err.error.message;
        this.msg.isError = true;
        this.isLoading = false;
        setTimeout(() => {
          this.msg.msg = "";
        }, 2000);
      })
  }
  get f() {
    return this.emailForm.controls;
  }

  get f1() {
    return this.resetForm.controls;
  }
  checkCode() {
    this.submitted = true;
    if (this.code) {
      let checkcode =
      {
        "verificationCode": this.code
      }
      this.subscription = this._service
        .checkCode(this.userId, checkcode)
        .subscribe((res) => {
          this.msg.msg = res.message;
          this.msg.isError = false;
          setTimeout(() => {
            this.msg.msg = "";
          }, 2000);
          this.isReset = true;
          this.createResetForm();
          this.submitted = false;
        }, err => {
          this.msg.msg = err.error.message;
          this.msg.isError = true;
          setTimeout(() => {
            this.msg.msg = "";
          }, 2000);
        })
    }
  }

  createResetForm() {
    this.resetForm = this.formBuilder.group({
      password: ["", [Validators.required]],
      retypePassword: ["", [Validators.required]],
    },
      { validator: this.passwordMatchValidator });
  }

  passwordMatchValidator(frm: FormGroup) {
    return frm.controls['password'].value === frm.controls['retypePassword'].value ? null : { 'mismatch': true };
  }

  forgetPassword() {
    this.submitted = true;
    if (this.resetForm.invalid) {
      return;
    } else {
      let temp = {
        password: this.resetForm.get("password").value,
        userId: this.userId
      }
      this.subscription = this._service.resetPassword(temp)
        .subscribe((res) => {
          localStorage.clear();
          this._router.navigate(['/home']);
        })
    }
  }
}
